import React, { useCallback } from "react";
import { Form, ValidState } from "./Form";
import { useDealActions } from "store";
import { useModals } from "hooks";

interface Props {
  dealId: number;
  refetchTable: () => void;
  onClose: () => void;
}

export const Create: React.FC<Props> = ({ dealId, refetchTable, onClose }) => {
  const { createMeasureFeeAction } = useDealActions();
  const { confirmModal } = useModals();

  const handleSubmit = useCallback(
    async (validState: ValidState) => {
      try {
        const { show_override_modal } = await createMeasureFeeAction({
          deal_id: dealId,
          ...validState,
          override_existing: false
        });
        if (!show_override_modal) {
          refetchTable();
          onClose();
          return;
        }
        confirmModal({
          msg: "Please note the dates you have selected already have managed fees added, do you want to Override",
          title: "Fees data overriding",
          action: async () => {
            await createMeasureFeeAction({
              deal_id: dealId,
              ...validState,
              override_existing: true
            });
            refetchTable();
            onClose();
          }
        });
      } catch (error) {
        throw error;
      }
    },
    [dealId]
  );

  return <Form dealId={dealId} onClose={onClose} onSubmit={handleSubmit} />;
};
